import { Injectable } from "@angular/core";
import { datadogLogs } from '@datadog/browser-logs';
import IDatadogLoggerConfig from './datadog.config.interface';
import { IProfile } from '../interfaces/azure/userprofile.interface';

@Injectable({
    providedIn: 'root'
})

export default class DatadogService {
    public initDatadogLogger(config: IDatadogLoggerConfig): void {
        datadogLogs.init(config)          
    }   

    public addUserContext(key: string, userProfile: IProfile) {
        // browser-logs v5+ renomeou Logger.addContext para setContextProperty.
        datadogLogs.logger.setContextProperty(key, userProfile)
    }

    public logInfo(message: string, context: object) {
        datadogLogs.logger.info(message, context)
    }
    
    public logError(message: string, context: object) {
        datadogLogs.logger.error(message, context)
    }

    public logWarning(message: string, context: object) {
        datadogLogs.logger.warn(message, context)
    }

}